import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";

export const SPECIALITIES = [
  ["CQC", "CQC — Adult social care"],
  ["Aesthetics", "CQC — Clinical Aesthetics"],
  ["Healthcare", "CQC — GP & Hospitals"],
  ["Ofsted", "Ofsted — Children's homes"],
  ["Fostering", "Ofsted — Independent Fostering Agencies"],
];

export const SpecialityAccessFields = ({ value, onChange, idPrefix }) => (
  <>
    <Select value={value.speciality || "none"} onValueChange={(v) => onChange({ speciality: v === "none" ? "" : v, full_access: v === "none" ? false : value.full_access })}>
      <SelectTrigger className="sm:col-span-3" data-testid={`${idPrefix}-speciality`}><SelectValue placeholder="Speciality (optional)" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">No speciality — they choose at onboarding</SelectItem>
        {SPECIALITIES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
      </SelectContent>
    </Select>
    <label className={`sm:col-span-3 flex items-center gap-2 text-sm rounded-md border border-input px-3 h-9 ${value.speciality ? "cursor-pointer" : "opacity-50"}`}>
      <Checkbox checked={value.full_access} disabled={!value.speciality} onCheckedChange={(c) => onChange({ ...value, full_access: !!c })} data-testid={`${idPrefix}-full-access`} />
      Unlock every policy pack for this speciality
    </label>
  </>
);
